// Espelho de TransicaoDePermissoes na API. Token sem a versão atual (emitido antes do deploy) mantém o acesso de
// quando foi emitido, até o próximo login.

/** Chave nova => chave antiga que liberava o mesmo. */
export const EQUIVALENCIAS_DO_TOKEN_ANTIGO: Record<string, string> = {
    vistoria_visualizar: 'locacao_visualizar',
    vistoria_novo: 'locacao_editar',
    vistoria_editar: 'locacao_editar',
    vistoria_excluir: 'locacao_excluir',
    trocadeoleo_visualizar: 'locacao_visualizar',
    trocadeoleo_editar: 'locacao_editar',
    trocadeoleo_excluir: 'locacao_excluir',
    contrato_visualizar: 'locacao_visualizar',
    contrato_novo: 'locacao_novo',
    contrato_editar: 'locacao_editar',
    contrato_excluir: 'locacao_excluir',
    rastreador_visualizar: 'empresa_visualizar',
    rastreador_bloquear: 'empresa_visualizar',
    configuracao_editar: 'empresa_visualizar',
};

export const ANTES_SEM_PERMISSAO = ['auditoria_visualizar', 'nfse_visualizar', 'nfse_emitir', 'nfse_cancelar'];

/** Espelho de PermissoesDoDashboard na API: um card do dashboard por chave. */
export const CARDS_DO_DASHBOARD: { chave: string; rotulo: string }[] = [
    { chave: 'dashboard_locacoes_ativas', rotulo: 'Locações ativas' },
    { chave: 'dashboard_locacoes_encerradas', rotulo: 'Locações encerradas' },
    { chave: 'dashboard_veiculos_disponiveis', rotulo: 'Veículos disponíveis' },
    { chave: 'dashboard_veiculos_em_locacao', rotulo: 'Veículos em locação' },
    { chave: 'dashboard_manutencoes', rotulo: 'Manutenções realizadas' },
    { chave: 'dashboard_investido_veiculos', rotulo: 'Investido em veículos' },
    { chave: 'dashboard_multas', rotulo: 'Multas' },
    { chave: 'dashboard_recebimentos_a_vencer', rotulo: 'Recebimentos a vencer' },
    { chave: 'dashboard_recebimentos_concluidos', rotulo: 'Recebimentos concluídos' },
    { chave: 'dashboard_recebimentos_em_atraso', rotulo: 'Recebimentos em atraso' },
    { chave: 'dashboard_despesas_resolvidas', rotulo: 'Despesas resolvidas' },
    { chave: 'dashboard_despesas_a_vencer', rotulo: 'Despesas a vencer' },
    { chave: 'dashboard_despesas_em_atraso', rotulo: 'Despesas em atraso' },
    { chave: 'dashboard_saldo', rotulo: 'Diferença entre entradas e saídas' },
    { chave: 'dashboard_vistorias', rotulo: 'Vistorias realizadas' },
    { chave: 'dashboard_trocas_de_oleo', rotulo: 'Trocas de óleo' },
    { chave: 'dashboard_grafico_faturamento', rotulo: 'Gráfico de faturamento por veículo' },
    { chave: 'dashboard_grafico_custo', rotulo: 'Gráfico de custo por veículo' },
    { chave: 'dashboard_grafico_lucro', rotulo: 'Gráfico de lucro por veículo' },
    { chave: 'dashboard_lista_pagamentos', rotulo: 'Lista de pagamentos' },
    { chave: 'dashboard_lista_lancamentos', rotulo: 'Lista de lançamentos' },
    { chave: 'dashboard_calendario', rotulo: 'Calendário de recebimentos' },
];

export const VERSAO_PERMISSOES = '2';

export interface DadosPermissoesDoToken {
    role?: string | string[];
    permissoes_versao?: string;
    administrador?: string;
}

export function permissoesEfetivas(dados: DadosPermissoesDoToken): Set<string> {
    const papeis = Array.isArray(dados.role) ? dados.role : [dados.role];
    const doToken = new Set(papeis.filter((p): p is string => Boolean(p)));
    if (dados.permissoes_versao === VERSAO_PERMISSOES) {
        return doToken;
    }

    const efetivas = new Set(doToken);
    Object.entries(EQUIVALENCIAS_DO_TOKEN_ANTIGO).forEach(([nova, antiga]) => {
        if (doToken.has(antiga)) efetivas.add(nova);
    });
    if (dados.administrador !== undefined) {
        ANTES_SEM_PERMISSAO.forEach(c => efetivas.add(c));
        efetivas.add('afiliacao_visualizar');
    }
    if (doToken.has('dashboard_visualizar')) {
        CARDS_DO_DASHBOARD.forEach(c => efetivas.add(c.chave));
    }
    return efetivas;
}
